import DeleteGenericModal from "../../modals/DeleteGenericModal";
import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useDeleteModal from "../../modals/useDeleteModal";
import axios from "axios";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {useNavigate} from "react-router-dom";
import {format} from "date-fns";
import useEditModal from "../../modals/useEditModal";
import * as React from "react";
import UploadConsejero from "../../components/UploadConsejero";
import GenericModal2 from "../../modals/GenericModal2";

const UserList = () => {

  const navigate = useNavigate()
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/usuario/list/superusuarios', []);

  const deleteElement = id => axios.delete(Apis.PROD + '/usuario/' + id)

  const formatoFecha = 'dd/MM/yyyy';

  const {
    wrapper: wrapper1,
    openDeleteModal
  } = useDeleteModal({
    text: '¿Desea eliminar este usuario?',
    action: deleteElement,
    onRefresh: fetchData
  })

  function addUser() {
    navigate('/usuarios/new')
  }

  function editUser(item) {
    navigate('/usuarios/edit/' + item.id)
  }

  const nameValue = useCallback(cell =>
    cell.row.original.nombres + ' ' + cell.row.original.apellidos
  , []);

  const fechaValue = useCallback(cell => {
    const fechaUTC = new Date(cell.renderValue() + new Date().getTimezoneOffset() * 60000);
    return format(fechaUTC, formatoFecha)
  }, []);

  const {wrapper: wrapper2, editAction} = useEditModal({
    editComponent: <UploadConsejero />,
    onRefresh: fetchData
  });

  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        <Button size='xs' variant='light' onClick={() => editUser(cell.row.original)}>Editar</Button>
        <Button size='xs' variant='danger' onClick={() => openDeleteModal(cell.row.original.id)}>Eliminar</Button>
        {(cell.row.original.tipoUsuario === "consejero") && <Button size='xs' variant='light' onClick={() => editAction({id: cell.row.original.id, url: cell.row.original.url})}>Foto</Button>}
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const columns = useMemo(
    () => [
      {
        header: 'Nombre',
        id: 'nombres',
        cell: nameValue
      },
      {
        header: 'Tipo de usuario',
        accessorKey: 'tipoUsuario',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        }
      },
      {
        header: 'Celular',
        accessorKey: 'nroCelular',
      },
      {
        header: 'Email',
        accessorKey: 'email',
      },
      {
        header: 'Sexo',
        accessorKey: 'sexo',
      },
      {
        header: 'Nacimiento',
        accessorKey: 'fechaNacimiento',
        cell: fechaValue
      },
      {
        header: 'Registro',
        accessorKey: 'fechaRegistro',
        cell: fechaValue
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Usuarios'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            filterAdd={() => addUser()}
            noData='No existen usuarios registrados'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <DeleteGenericModal {...wrapper1} />
      <GenericModal2 {...wrapper2} />
    </PageContainerFull>
  )
}

export default UserList
